const w = config => config.width - config.margin.right - config.margin.left;

export default w;
